<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row class="mt-10" align="center" justify="center">
      <v-col class="text-center">
        <span class="text-tcdc-green header bold">
          {{ our_service ? our_service.our_service_main[`name_${lang}`] : $t('our-service.title')}}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div v-if="our_service" class="vhtml" v-html="our_service.our_service_main[`description_${lang}`]"></div>
        <div v-else class="vhtml">{{$t('our-service.content')}}</div>
      </v-col>
    </v-row>
    <v-row class="my-5">
<!--      <v-layout :column="$vuetify.breakpoint.smAndDown">-->
<!--        <v-flex md4 mb-5 mb-md-0 v-for="(item, i) of imagesList" :key="i">-->
<!--          <OurServiceCard :item="item" @onPress="routeTo(item.path, item.id)" />-->
<!--        </v-flex>-->
<!--      </v-layout>-->

      <template v-for="(item, index) in imagesList">
        <v-col cols="12" :md="4" :key="index">
          <OurServiceCard :item="item" @onPress="routeTo(item.path, item.id)" />
        </v-col>
      </template>

    </v-row>
  </v-container>
</template>

<script>
import OurServiceCard from "../../components/cards/OurServiceCard";
import GreenButton from "../../components/buttons/GreenButton";
import { mapState } from "vuex";
import { BreadcrumbUtil } from "../../util/BreadcrumbUtil";

export default {
  components: {
    OurServiceCard,
    // GreenButton
  },
  created() {
    this.$store.dispatch("ServiceMenu/getAllOurService").then(res=>{
      this.imagesList = res.our_services;
    });
    this.items = BreadcrumbUtil.setServiceItem(
            this.items,
            this.branchId,
            this.branchName,
            this.allBranches,
            this.lang
    )
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      branchId: state => state.Branch.branch_id,
      allBranches: state => state.Branch.branches,
      lang: state => state.Branch.lang,
      our_service: state => state.ServiceMenu.our_service,
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
              this.items,
              this.branchId,
              this.branchName,
              this.allBranches,
              this.lang
      )
    },
    lang: function () {
    }
  },
  methods: {
    routeTo(path, id) {
      this.$router.push({ path: `our-service/` +path, query: { id: id } });
    }
  },
  data: () => ({
    items: [
      {
        text: 'ALL BRANCHES',
        disabled: false,
        href: "/home"
      },
      {
        text: "OUR SERVICE",
        disabled: false
      }
    ],
    imagesList: []
  })
};
</script>

<style>
</style>
